// This file is generated automatically
// Don't edit this file directly

import { call, toParams } from './utils'

export let api_origin = '/api'

// GET /api/tripo3d/balance
export function DEV_getAPIBalance(input: DEV_getAPIBalanceInput): Promise<DEV_getAPIBalanceOutput & { error?: string }> {
  return call('GET', api_origin + `/tripo3d/balance`)
}
export type DEV_getAPIBalanceInput = {
}
export type DEV_getAPIBalanceOutput = {
  code: number
  data: {
    balance: number
    frozen: number
  }
}

// POST /api/tripo3d/generate/prompt
export function tripo3d_Prompt2Model(input: Tripo3d_Prompt2ModelInput): Promise<Tripo3d_Prompt2ModelOutput & { error?: string }> {
  return call('POST', api_origin + `/tripo3d/generate/prompt`, input.body)
}
export type Tripo3d_Prompt2ModelInput = {
  body: {
    prompt: string
    style?: string
  }
}
export type Tripo3d_Prompt2ModelOutput = {
  object_id: number
}

// GET /api/tripo3d/model/:object_id
export function tripo3d_loadModel(input: Tripo3d_loadModelInput): Promise<Tripo3d_loadModelOutput & { error?: string }> {
  let { params } = input
  return call('GET', api_origin + `/tripo3d/model/${params.object_id}`)
}
export type Tripo3d_loadModelInput = {
  params: {
    object_id: string
  }
}
export type Tripo3d_loadModelOutput = {
  status: string
  progress?: number
  prompt?: string
  user?: string
  urls?: {
    model?: string
    preview?: string
    render?: string
  }
}

// GET /api/tripo3d/latest_model
export function tripo3d_latest_model(input: Tripo3d_latest_modelInput): Promise<Tripo3d_latest_modelOutput & { error?: string }> {
  return call('GET', api_origin + `/tripo3d/latest_model`)
}
export type Tripo3d_latest_modelInput = {
}
export type Tripo3d_latest_modelOutput = {
  object_id_array: Array<number>
}

// POST /api/tripo3d/:object_id/bookmark
export function bookmarkObject(input: BookmarkObjectInput): Promise<BookmarkObjectOutput & { error?: string }> {
  let { params } = input
  return call('POST', api_origin + `/tripo3d/${params.object_id}/bookmark`)
}
export type BookmarkObjectInput = {
  params: {
    object_id: number
  }
}
export type BookmarkObjectOutput = {
}

// DELETE /api/tripo3d/:object_id/bookmark
export function unBookmarkObject(input: UnBookmarkObjectInput): Promise<UnBookmarkObjectOutput & { error?: string }> {
  let { params } = input
  return call('DELETE', api_origin + `/tripo3d/${params.object_id}/bookmark`)
}
export type UnBookmarkObjectInput = {
  params: {
    object_id: number
  }
}
export type UnBookmarkObjectOutput = {
}

// GET /api/tipo3d/:object_id/bookmark
export function getObjectBookmark(input: GetObjectBookmarkInput): Promise<GetObjectBookmarkOutput & { error?: string }> {
  let { params } = input
  return call('GET', api_origin + `/tipo3d/${params.object_id}/bookmark`)
}
export type GetObjectBookmarkInput = {
  params: {
    object_id: number
  }
}
export type GetObjectBookmarkOutput = {
  isBookmarked: boolean
}
